import { render, staticRenderFns } from "./GreenBudgetDetailsForm.vue?vue&type=template&id=4de5731d&"
import script from "./GreenBudgetDetailsForm.vue?vue&type=script&lang=js&"
export * from "./GreenBudgetDetailsForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/tgs-automation/tgs-automation/mojaweb/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4de5731d')) {
      api.createRecord('4de5731d', component.options)
    } else {
      api.reload('4de5731d', component.options)
    }
    module.hot.accept("./GreenBudgetDetailsForm.vue?vue&type=template&id=4de5731d&", function () {
      api.rerender('4de5731d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/carbonclap/components/green/form/GreenBudgetDetailsForm.vue"
export default component.exports